import { getUser } from '../api/api.js';
import { createRouter } from '@/router' // 引入路由实例

export default {
	install(Vue, options) {
		//全局变量
		Vue.prototype.common = {
			//保存cookie
			setCookie: function (name, value, day) {
				var exdays = 1;
				if(day != null){
					exdays = day;
				}
				var d = new Date();
				d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
				// d.setTime(d.getTime() + (exdays * 10 * 1000));
				var expires = "expires=" + d.toGMTString();
				document.cookie = name + "=" + encodeURIComponent(value) + "; " + expires + ";path=/";
				// document.cookie = name + "=" + value;
				
			},

			//获取cookie
			getCookie: function (name) {
				var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

				if (arr = document.cookie.match(reg))

					return decodeURIComponent(arr[2]);
				else
					return null;
			},

			//删除cookie
			delCookie: function (name) {
				var exp = new Date();
				exp.setTime(exp.getTime() - 1);

				var cval = this.getCookie(name);
				
				console.log(exp)
				console.log(exp.toGMTString())
				if (cval != null){
					console.log(exp)
					console.log(exp.toGMTString())
					document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
				}
			},

			//localStorage存储数据
			infoStorage: function (name, value) {
				localStorage.setItem(name, value);
			},

			//localStorage获取数据
			getStorage: function (name) {
				return localStorage.getItem(name);
			},

			//localStorage删除数据
			delStorage: function (name) {
				if (localStorage.getItem(name) != null) {
					localStorage.removeItem(name);
				}
			},

			//日期处理
			dateStr: function(str,formal){
				const date = new Date(str*1000);
				const YYYY = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? '0' + MM : MM;
				let dd = date.getDate();
				dd = dd < 10 ? '0' + dd : dd;
				let HH = date.getHours();
				HH = HH < 10 ? '0' + HH : HH;
				let mm = date.getMinutes();
				mm = mm < 10 ? '0' + mm : mm;
				let ss = date.getSeconds();
				ss = ss < 10 ? '0' + ss : ss;
				let ww = date.getDay();

				if(formal){
					var formalText = formal;
				}else{
					var formalText = 'YYYY-MM-dd';
				}
				
				return formalText.replace('YYYY',YYYY)
							 .replace('MM',MM)
							 .replace('dd',dd)
							 .replace('HH',HH)
							 .replace('mm',mm)
							 .replace('ss',ss)
							 .replace('ww',ww);
			},

			//时间处理
			timeStr: function (str) {
				const date = new Date(str * 1000);
				const YYYY = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? '0' + MM : MM;
				let dd = date.getDate();
				dd = dd < 10 ? '0' + dd : dd;
				let HH = date.getHours();
				HH = HH < 10 ? '0' + HH : HH;
				let mm = date.getMinutes();
				mm = mm < 10 ? '0' + mm : mm;
				let ss = date.getSeconds();
				ss = ss < 10 ? '0' + ss : ss;

				let formal;
				formal = 'HH:mm';

				return formal.replace('HH', HH)
					.replace('mm', mm);
			},
			
			//递归合并
			mergeObjects(obj1, obj2){
				function mergeObjects(obj1, obj2) {
					for (const key in obj2) {
						if (obj2.hasOwnProperty(key)) {
							if (typeof obj2[key] === 'object' && obj2[key] !== null && obj1[key]) {
								// 递归合并对象
								mergeObjects(obj1[key], obj2[key]);
							} else {
								// 直接替换键值
								obj1[key] = obj2[key];
							}
						}
					}
				}
				const result = { ...obj1 };
				mergeObjects(result, obj2);
				return result;
			},

			// 获取数据JSON转换
			jsonParse: function (data=null) {
				return JSON.parse(JSON.stringify(data));
			},

			// 获取地址参数
			GetQueryString: function (name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
				var r = window.location.search.substr(1).match(reg);
				if (r != null)
					return unescape(r[2]);
				return 'undefined';
			},
			
			// cookie昵称处理
			getUserName(nickname){
				let _nickname = nickname;
				_nickname = _nickname.replace(/-/g,'%');
            	_nickname = unescape(_nickname);

				return _nickname;	
			},

			// 文本格式
			formalTitle(val){
				//console.log('val', val)

				let title = val.toLowerCase();
        
				// let a = '1:2：3"4“5”6\'7？8' + "'s    9" + '?'
				let Exp=/[\:\：\“\”\"\‘\’\'\?\？\%\!\！]/g;
				title = title.replace(Exp,"")
				title = title.replace(/ /g, '-')

				return title;
			},

			// 是否已登录
			isLogin: function () {
				let _userInfo = this.getCookie('userInfo');
				
				if(!(typeof(_userInfo) != 'undefined' && _userInfo != null)){
					this.delCookie('userInfo');
					localStorage.clear();
					createRouter().push({ path: "/login", query: { redirect: createRouter().currentRoute.path }})
					// return new Promise((resolve, reject) => {
					// 	return resolve(true);
					// });
					return false
				}
				
				
			},

			// 千位分隔
			numberWithCommas(val) {
				if(typeof(val) == 'undefined'){
					return 0;
				}
				
				var parts = val.toString().split(".");
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				return parts.join(".");
			},
			// 字符串字符长度截取 num为中文字数
			displayedString(str, num) {
				let _str = str;
				let _num = num;
				let length = 0;
				for (let i = 0; i < _str.length; i++) {
				  if (_str.charCodeAt(i) > 255) {
					length += 2; // 中文字符长度为2
				  } else {
					length += 1; // 英文字符长度为1
				  }
				  if (length > _num*2 || (length > _num && _str.charCodeAt(i) > 255)) {
					_str = _str.substring(0, i) + '...';
					break;
				  }
				}
				return _str;
			},

			// 更新link[rel="canonical"]
			updateLink(name){
				let link = document.querySelector('link[rel*="'+ name +'"]');
				link.href = window.location.href;
			},

			isMobile() {
				const userAgent = navigator.userAgent;
				const mobileKeywords = ['Android', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'Windows Phone'];
				for (let i = 0; i < mobileKeywords.length; i++) {
					if (userAgent.indexOf(mobileKeywords[i]) !== -1) {
						return true;
					}
				}
				return false;
			}
		},
		

		Vue.prototype.$socket = 'socket';
	}
}


// WEBPACK FOOTER //
// ./src/utils/common.js